<script>
  import TabelaDetalhe from './TabelaDetalhe.vue';
  import cursoServico from '../servico';
  
  export default {
    components: {TabelaDetalhe},
    data() {
      return {
        animated: true,
        cursos: [],
      }
    },
    methods: {
      listar() {
        cursoServico
          .lista()
          .then(cursos => {
            this.cursos = cursos;
          });
      }
    },
    created() {
      this.listar();
    },
    mounted() {
      this.$root.tituloDaPagina = 'Cursos';
      this.$events.on('recarregarCursos', this.listar);

      this.$root.botaoAcaoMostrar = false;
    }
  }
</script>

<template>
  <div>
    <div class="modal fade" id="ModalPlataformasPgto" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p>
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span style="font-size: 16px;margin-left: 10px;">Entrando em contato com o provedor. Aguarde...</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="ibox float-e-margins">
      <div class="ibox-content">

        <div class="row">
          <div class="col-lg-12">

            <div class="table-responsive">
              <tabela-detalhe :dados="cursos"></tabela-detalhe>
            </div>

          </div>
        </div>

      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/curso/componentes/Lista.vue